module.exports = __webpack_public_path__ + "media/honey-icons/slt6-d073162f.svg";